"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitTestIgnore = UnitTestIgnore;
/**
 * Decorator to indicate a typescript class should be ignored by the unit test generator
 */
function UnitTestIgnore() {
    return function (target) { };
}
